"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteriskAnnouncePositionEnum = void 0;
var AsteriskAnnouncePositionEnum;
(function (AsteriskAnnouncePositionEnum) {
    AsteriskAnnouncePositionEnum["YES"] = "yes";
    AsteriskAnnouncePositionEnum["NO"] = "no";
    AsteriskAnnouncePositionEnum["LIMIT"] = "limit";
    AsteriskAnnouncePositionEnum["MORE"] = "more";
})(AsteriskAnnouncePositionEnum = exports.AsteriskAnnouncePositionEnum || (exports.AsteriskAnnouncePositionEnum = {}));
